import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getCoreContentTags = createAsyncThunk(`core/contentTags/getCoreContentTags`, async (payload) => {
  try {
    const response = await coreAPIs.getCoreContentTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const saveCoreContentTags = createAsyncThunk(`core/contentTags/saveCoreContentTags`, async (payload) => {
  try {
    const response = await coreAPIs.saveCoreContentTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
